import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext.tsx';
import indexFundsService from "@indexFundsService";

export function useFetchIndexFundHoldings() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['index-fund-holdings', user?.id],
    queryFn: async () => {
      return await indexFundsService.fetchIndexFundHoldings(user.id);
    },
    enabled: !!user,
  });
}

export function useCreateIndexFundHolding() {
  const qc = useQueryClient();
  const { user } = useAuth();
  return useMutation({
    mutationFn: async (holding: Omit<IndexFundHoldingCreateRequest, 'userId'>) => {
      return await indexFundsService.createIndexFundHolding({...holding, userId: user.id});
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['index-fund-holdings'] }),
  });
}

export function useUpdateIndexFundHolding() {
  const qc = useQueryClient();
  const { user } = useAuth();
  return useMutation({
    mutationFn: async (req: Omit<IndexFundHoldingUpdateRequest, 'userId'>) => {
      return await indexFundsService.updateIndexFundHolding({...req, userId: user.id})
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['index-fund-holdings'] }),
  });
}

export function useDeleteIndexFundHolding() {
  const qc = useQueryClient();
  const { user } = useAuth();
  return useMutation({
    mutationFn: async (id: string) => {
      return await indexFundsService.deleteIndexFundHolding({ id, userId: user.id });
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['index-fund-holdings'] }),
  });
}
